import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { ForbrukPage } from './forbruk.page';
import { ComponentsModule } from 'src/app/shared/components.module';
import { DayChartUsageComponent } from './graphs/forbruk/charts/forbruk/day-chart-usage/day-chart-usage.component';
import { HourChartUsageComponent } from './graphs/forbruk/charts/forbruk/hour-chart-usage/hour-chart-usage.component';
import { MonthChartUsageComponent } from './graphs/forbruk/charts/forbruk/month-chart-usage/month-chart-usage.component';
import { YearChartUsageComponent } from './graphs/forbruk/charts/forbruk/year-chart-usage/year-chart-usage.component';
import { DayChartPriceComponent } from './graphs/kostnad/charts/kostnad/day-chart-price/day-chart-price.component';
import { HourChartPriceComponent } from './graphs/kostnad/charts/kostnad/hour-chart-price/hour-chart-price.component';
import { MonthChartPriceComponent } from './graphs/kostnad/charts/kostnad/month-chart-price/month-chart-price.component';
import { YearChartPriceComponent } from './graphs/kostnad/charts/kostnad/year-chart-price/year-chart-price.component';
import { NokkeltallComponent } from './nokkeltall/nokkeltall.component';
import { KostnadstallComponent } from './graphs/kostnad/kostnadstall/kostnadstall.component';
import { ForbrukstallComponent } from './graphs/forbruk/forbrukstall/forbrukstall.component';
import { GraphtextComponent } from './graphtext/graphtext.component';
import { ViewpickerComponent } from './viewpicker/viewpicker.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { NokkeltallYearComponent } from './nokkeltall/year/year.component';
import { NokkeltallMonthComponent } from './nokkeltall/month/month.component';
import { NokkeltallDayComponent } from './nokkeltall/day/day.component';
import { NokkeltallHourComponent } from './nokkeltall/hour/hour.component';
import { GraphsComponent } from './graphs/graphs.component';
import { ForbrukComponent } from './graphs/forbruk/forbruk.component';
import { KostnadComponent } from './graphs/kostnad/kostnad.component';
import { ForbrukDayComponent } from './graphs/forbruk/forbrukstall/day/day.component';
import { ForbrukHourComponent } from './graphs/forbruk/forbrukstall/hour/hour.component';
import { ForbrukChartComponent } from './graphs/forbruk/charts/forbruk/forbruk.component';
import { KostnadstallDayComponent } from './graphs/kostnad/kostnadstall/day/day.component';
import { KostnadstallHourComponent } from './graphs/kostnad/kostnadstall/hour/hour.component';
import { KostnadstallMonthComponent } from './graphs/kostnad/kostnadstall/month/month.component';
import { KostnadstallYearComponent } from './graphs/kostnad/kostnadstall/year/year.component';
import { ChartKostnadComponent } from './graphs/kostnad/charts/kostnad/kostnad.component';
import { DayComponent } from './graphs/kostnad/stromstotte/day/day.component';
import { MonthComponent } from './graphs/kostnad/stromstotte/month/month.component';
import { routes } from './forbruk.routes';
import { DownloadForbrukPopupPage } from './download-forbruk-popup/download-forbruk-popup.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    RouterModule.forChild(routes),
    DownloadForbrukPopupPage
  ],
  declarations: [
    ForbrukPage,
    DayChartUsageComponent,
    HourChartUsageComponent,
    MonthChartUsageComponent,
    YearChartUsageComponent,
    DayChartPriceComponent,
    HourChartPriceComponent,
    MonthChartPriceComponent,
    YearChartPriceComponent,
    NokkeltallComponent,
    KostnadstallComponent,
    ForbrukstallComponent,
    GraphtextComponent,
    ViewpickerComponent,
    DatepickerComponent,
    NokkeltallYearComponent,
    NokkeltallMonthComponent,
    NokkeltallDayComponent,
    NokkeltallHourComponent,
    GraphsComponent,
    ForbrukComponent,
    KostnadComponent,
    ForbrukDayComponent,
    ForbrukHourComponent,
    ForbrukChartComponent,
    KostnadstallDayComponent,
    KostnadstallHourComponent,
    KostnadstallMonthComponent,
    KostnadstallYearComponent,
    ChartKostnadComponent,
    DayComponent,
    MonthComponent
  ]
})
export class ForbrukPageModule {}
